

export function pick3DTileset(scene, positions) {
    if (!positions) return null;

    if (positions instanceof Cesium.Cartesian3) positions = [positions];

    for (var i = 0, len = positions.length; i < len; ++i) {
        var position = positions[i];
        var coorPX = Cesium.SceneTransforms.wgs84ToWindowCoordinates(scene, position);
        if (!Cesium.defined(coorPX)) continue;

        var pickedObject = scene.pick(coorPX, 10, 10);
        if (Cesium.defined(pickedObject) && Cesium.defined(pickedObject.primitive) && pickedObject.primitive instanceof Cesium.Cesium3DTileset) {
            return pickedObject.primitive;
        }
    }

    return null;
}